import { render } from "./MobileMenuDetails.vue?vue&type=template&id=12c84410&scoped=true"
import script from "./MobileMenuDetails.vue?vue&type=script&lang=js"
export * from "./MobileMenuDetails.vue?vue&type=script&lang=js"

import "./MobileMenuDetails.vue?vue&type=style&index=0&id=12c84410&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12c84410"]])

export default __exports__